import './RegistrationForm.css'
import { deleteObject, getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { addDoc, getDocs } from 'firebase/firestore';
import { storage, registerRef, userRef, transactionIdRef } from '../../firebase';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import { Button } from 'rsuite';
import 'react-toastify/dist/ReactToastify.css';



const indian = [
    { id: 0, typeofAuthor: 'Select', amount: 0 },
    { id: 1, typeofAuthor: 'Author', amount: 'INR 8500' },
    { id: 2, typeofAuthor: 'IEEE Author', amount: 'INR 6800' },
    { id: 3, typeofAuthor: 'Invited Presentation', amount: 'INR 6500' },
    { id: 4, typeofAuthor: 'Student Author', amount: 'INR 5000' },
    { id: 5, typeofAuthor: 'Student IEEE Author', amount: 'INR 4000' },
    { id: 6, typeofAuthor: 'Attendee/Listener', amount: 'INR 1000' },
    { id: 7, typeofAuthor: 'Additional Paper Fee', amount: 'INR 5000' },
];

const otherNation = [
    { id: 0, typeofAuthor: 'Select', amount: 0 },
    { id: 1, typeofAuthor: 'Author', amount: 'USD 350' },
    { id: 2, typeofAuthor: 'IEEE Author', amount: 'USD 280' },
    { id: 3, typeofAuthor: 'Invited Presentation', amount: 'USD 250' },
    { id: 4, typeofAuthor: 'Student Author', amount: 'USD 200' },
    { id: 5, typeofAuthor: 'Student IEEE Author', amount: 'USD 160' },
    { id: 6, typeofAuthor: 'Attendee/Listener', amount: 'USD 100' },
    { id: 7, typeofAuthor: 'Additional Paper Fee', amount: 'USD 300' },
];

const RegistrationForm = () => {
    const mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [paperId, setPaperId] = useState('');
    const [memberNum, setMemberNum] = useState('');
    const [title, setTitle] = useState('');
    const [student, setStudent] = useState(null);
    const [ieeeMember, setIeeeMember] = useState(null);
    const [nationality, setNationality] = useState(null);
    const [phnNum, setPhnNum] = useState('');
    const [membershipCard, setMemberShipCard] = useState(null);
    const [idCard, setIdCard] = useState(null);
    const [transactionId, setTransactionId] = useState('');
    const [paymentProof, setPaymentProof] = useState(null);
    const [submitButtonDisable, setSubmitButtonDisable] = useState(false);
    const [isLoading, setIsLoading] = useState('none');
    var membershipCardURL = null;
    var studentCardURL = null;
    var paymentProofURL = null;
    const navigate = useNavigate();
    var paperIds = [];
    var transactionIds = [];
    var value = null;

    const [selected, setSelected] = useState(-1);
    if (nationality) {
        value = selected !== -1 && indian[selected];
    }
    else {
        value = selected !== -1 && otherNation[selected];
    }

    var amount = value.amount;
    var typeOfAuthor = value.typeofAuthor;


    const getInfo = async () => {
        const querySnapshot = await getDocs(registerRef);
        querySnapshot.forEach((docs) => {
            transactionIds.push(docs.data().transactionId);
            paperIds.push(docs.data().paperId);
        })
    }
    // getInfo();


    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading('flex');
        setSubmitButtonDisable(true);

        if (!email || !name || !paperId || !title || !phnNum || !transactionId || !paymentProof || nationality === null) {
            setSubmitButtonDisable(false);
            toast.warning("Fill all the fields", { position: toast.POSITION.BOTTOM_RIGHT });
            setIsLoading('none');
            return;
        }

        else if (amount === 0 || amount === undefined || typeOfAuthor === 'Select' || typeOfAuthor === undefined) {
            setSubmitButtonDisable(false);
            toast.warning("Please select the type of Author", { position: toast.POSITION.BOTTOM_RIGHT });
            setIsLoading('none');
            return;
        }

        else if (student === null) {
            setSubmitButtonDisable(false);
            toast.warning("Please select wheather you are a student or not", { position: toast.POSITION.BOTTOM_RIGHT });
            setIsLoading('none');
            return;
        }

        else if (ieeeMember === null) {
            setSubmitButtonDisable(false);
            toast.warning("Please select wheather you are an IEEE member or not", { position: toast.POSITION.BOTTOM_RIGHT });
            setIsLoading('none');
            return;
        }

        else if (student === true && (idCard === null || idCard === undefined)) {
            setSubmitButtonDisable(false);
            toast.warning("Please upload your ID card", { position: toast.POSITION.BOTTOM_RIGHT });
            setIsLoading('none');
            return;
        }

        else if (nationality === null) {
            setSubmitButtonDisable(false);
            toast.warning("Please select your nationality", { position: toast.POSITION.BOTTOM_RIGHT });
            setIsLoading('none');
            return;
        }

        else if (ieeeMember === true && !memberNum) {
            setSubmitButtonDisable(false);
            toast.warning("Please enter your IEEE-Membership number", { position: toast.POSITION.BOTTOM_RIGHT });
            setIsLoading('none');
            return;
        }

        else if (ieeeMember === true && (membershipCard === null || membershipCard === undefined)) {
            setSubmitButtonDisable(false);
            toast.warning("Please upload your IEEE-Membership card", { position: toast.POSITION.BOTTOM_RIGHT });
            setIsLoading('none');
            return;
        }

        else if (!(email).match(mailformat)) {
            setSubmitButtonDisable(false);
            toast.warning("Invalid email id", { position: toast.POSITION.BOTTOM_RIGHT });
            setIsLoading('none');
            return;
        }

        else if (phnNum < 6000000000 || phnNum > 9999999999) {
            setSubmitButtonDisable(false);
            toast.warning("Invalid Phone number", { position: toast.POSITION.BOTTOM_RIGHT });
            setIsLoading('none');
            return;
        }

        else if (paperIds.includes(paperId)) {
            setSubmitButtonDisable(false);
            toast.warning("This Paper ID have already been submitted", { position: toast.POSITION.BOTTOM_RIGHT });
            setIsLoading('none');
            return;
        }

        if (transactionIds.includes(transactionId)) {
            await addDoc(transactionIdRef, {
                name: name,
                email: email,
                phoneNumber: phnNum,
                paperId: paperId,
                transactionId: transactionId
            });
        }

        setSubmitButtonDisable(true);

        var membershipCardRef = null;
        try {
            membershipCardRef = ref(storage, `/membershipCard/${paperId}-${membershipCard.name}`);
            if (ieeeMember === true) {
                try {
                    await uploadBytes(membershipCardRef, membershipCard)
                        .then(async (snapshot) => {
                            membershipCardURL = await getDownloadURL(snapshot.ref);
                        });
                }
                catch (e) {
                    setIsLoading('none');
                    setSubmitButtonDisable(false);
                    toast.warning("Error uploading Membership Card", { position: toast.POSITION.BOTTOM_RIGHT });
                    return;
                }
            }
        }
        catch (e) {
            membershipCardRef = null;
        }

        const paymentProofRef = ref(storage, `/paymentProof/${paperId}-${paymentProof.name}`);
        try {
            await uploadBytes(paymentProofRef, paymentProof)
                .then(async (snapShot) => {
                    paymentProofURL = await getDownloadURL(snapShot.ref);
                })
        }
        catch (e) {
            deleteObject(membershipCardRef);
            setIsLoading('none');
            setSubmitButtonDisable(false);
            toast.warning("Error uploading Payment Proof", { position: toast.POSITION.BOTTOM_RIGHT });
            return;
        }

        var studentCardRef = null;

        try {
            studentCardRef = ref(storage, `/studentID/${paperId}-${idCard.name}`);
            if (student === true) {
                try {
                    await uploadBytes(studentCardRef, idCard)
                        .then(async (snapShot) => {
                            studentCardURL = await getDownloadURL(snapShot.ref);
                        });
                }
                catch (e) {
                    deleteObject(membershipCardRef);
                    deleteObject(paymentProofRef);
                    setIsLoading('none');
                    setSubmitButtonDisable(false);
                    toast.warning("Error uploading Student ID", { position: toast.POSITION.BOTTOM_RIGHT });
                    return;
                }
            }
        }
        catch (e) {
            studentCardRef = null;
        }

        try {
            await addDoc(registerRef, {
                name: name,
                email: email,
                phoneNumber: phnNum,
                paperId: paperId,
                transactionId: transactionId
            });

            if (student === true) {
                if (paymentProofURL !== null && studentCardURL !== null) {
                    await addDoc(userRef, {
                        name: name,
                        phnNum: phnNum,
                        email: email,
                        paperId: paperId,
                        typeOfAuthor: typeOfAuthor,
                        membershipNum: memberNum,
                        title: title,
                        ieeeMember: ieeeMember,
                        student: student,
                        studentIdCard: studentCardURL,
                        membershipCard: membershipCardURL,
                        transactionId: transactionId,
                        paymentProof: paymentProofURL,
                        applicationDate: new Date().toDateString()
                    })
                }

                else if (studentCardURL === null) {
                    throw new Error("Error uploading Student ID");
                }

                else if (paymentProofURL === null) {
                    throw new Error("Error uploading Payment Proof");
                }
                else {
                    throw new Error("An error occured while registeration!! Please try again");
                }
            }

            else if (student === false) {
                if (paymentProofURL !== null) {
                    await addDoc(userRef, {
                        name: name,
                        phnNum: phnNum,
                        email: email,
                        paperID: paperId,
                        typeOfAuthor: typeOfAuthor,
                        membershipNum: memberNum,
                        ieeeMember: ieeeMember,
                        title: title,
                        membershipCard: membershipCardURL,
                        transactionId: transactionId,
                        paymentProof: paymentProofURL,
                        applicationDate: new Date().toDateString()
                    })
                }
                else if (paymentProofURL === null) {
                    throw new Error("Error uploading Payment Proof");
                }

                else {
                    throw new Error("An error occured while registeration!! Please try again");
                }
            }

            else {
                setIsLoading('none');
                throw new Error("An error occured while registeration!! Please try again");
            }
            setIsLoading('none');

            navigate('/acknowledge', { state: { abfp: paperId } })

        }
        catch (e) {
            try {
                if (ieeeMember === true) {
                    try {
                        deleteObject(membershipCardRef);
                    }
                    catch (err) { }
                }
                deleteObject(paymentProofRef);
                if (student === true) {
                    try {
                        deleteObject(studentCardRef);
                    }
                    catch (err) { }
                }
            }
            catch (err) {
            }
            setIsLoading('none');
            setSubmitButtonDisable(false);
            toast.warning(e.message, { position: toast.POSITION.BOTTOM_RIGHT });
            return;
        }
    }

    return (
        <div className="RegistrationForm">
            <h1 style={{ textAlign: 'center' }}>Registration Form</h1>
            <div className='container'>
                <b><mark>If you are a Listener, Please put paper title as XYZ and Paper ID as 9999</mark></b>
                <form method='post' className="form">
                    <div className="input-box">
                        <label>Author Name</label>
                        <input type="text" placeholder="Enter full name" required onChange={(e) => setName(e.target.value)} />
                    </div>
                    <div className="column">
                        <div className="input-box">
                            <label>Paper ID</label>
                            <input type="number" placeholder="Eg. 423651" required onChange={(e) => setPaperId(e.target.value)} />
                        </div>
                        <div className="input-box">
                            <label>Paper title</label>
                            <input type="text" placeholder="Enter paper title" required onChange={(e) => setTitle(e.target.value)} />
                        </div>
                    </div>
                    <div className="column">
                        <div className="input-box">
                            <label>Phone Number</label>
                            <input type="number" placeholder="Enter phone number" required onChange={(e) => setPhnNum(e.target.value)} />
                        </div>
                        <div className="input-box">
                            <label>Email Address</label>
                            <input type="email" placeholder="Enter email address" required onChange={(e) => setEmail(e.target.value)} />
                        </div>
                    </div>
                    <div className="column">
                        <div className="student-box">
                            <label>Are you a IEEE member?</label>
                            <div className="student-option">
                                <div className="member">
                                    <input type="radio" id="check-Yes" name="ieee-member" onChange={() => setIeeeMember(true)} />
                                    <label htmlFor="check-Yes">Yes</label>
                                </div>
                                <div className="student">
                                    <input type="radio" id="check-No" name="ieee-member" onChange={() => setIeeeMember(false)} />
                                    <label htmlFor="check-No">No</label>
                                </div>
                            </div>
                        </div>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <div className="student-box">
                            <label>Are you a student?</label>
                            <div className="student-option">
                                <div className="student">
                                    <input type="radio" id="student-Yes" name="student" onChange={() => setStudent(true)} />
                                    <label htmlFor="student-Yes">Yes</label>
                                </div>
                                <div className="student">
                                    <input type="radio" id="student-No" name="student" onChange={() => setStudent(false)} />
                                    <label htmlFor="student-No">No</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="student-box">
                        <label>Are you an Indian?</label>
                        <div className="student-option">
                            <div className="nationality">
                                <input type="radio" id="nationality-Yes" name="nationality" onChange={() => setNationality(true)} />
                                <label htmlFor="nationality-Yes">Yes</label>
                            </div>
                            <div className="student">
                                <input type="radio" id="nationality-No" name="nationality" onChange={() => setNationality(false)} />
                                <label htmlFor="nationality-No">No</label>
                            </div>
                        </div>
                    </div>
                    {nationality && <div className="column">
                        <div className="student-box">
                            <label>Type of Author?</label>
                            <div className="column">
                                <select
                                    onChange={(e) => setSelected(e.target.value)}
                                    value={selected}>
                                    {indian.map((m, ix) => {
                                        return <option value={ix} key={ix}> {m.typeofAuthor} </option>
                                    })};
                                </select>
                                {value &&
                                    <div className='displayAmount'>
                                        <span> {value.amount}</span>
                                    </div>}
                            </div>
                        </div>
                    </div>}
                    {!nationality && <div className="column">
                        <div className="student-box">
                            <label>Type of Author?</label>
                            <div className="column">
                                <select
                                    onChange={(e) => setSelected(e.target.value)}
                                    value={selected}>
                                    {otherNation.map((m, ix) => {
                                        return <option value={ix} key={ix}> {m.typeofAuthor} </option>
                                    })};
                                </select>
                                {value &&
                                    <div className='displayAmount'>
                                        <span> {value.amount}</span>
                                    </div>}
                            </div>
                        </div>
                    </div>}
                    <div className="input-box address">
                        <div className="column">
                            {ieeeMember && <div className="input-box">
                                <label>Upload IEEE membership card</label>
                                <input type="file" required style={{ padding: '1.2rem' }} onChange={(e) => { setMemberShipCard(e.target.files[0]) }} />
                            </div>}
                            {ieeeMember && <div className="input-box">
                                <label>IEEE membership number</label>
                                <input type="number" placeholder="Eg. 1023" required onChange={(e) => setMemberNum(e.target.value)} />
                            </div>}
                        </div>
                        {student && <div className="input-box">
                            <label>Upload Student ID card</label>
                            <input type="file" placeholder="upload id card" style={{ padding: '1.2rem' }} onChange={(e) => { setIdCard(e.target.files[0]) }} />
                        </div>}
                        <div className="column">
                            <div className="input-box">
                                <label>Transaction Id</label>
                                <input type="number" placeholder="Enter Transaction Id" required onChange={(e) => setTransactionId(e.target.value)} />
                            </div>
                            <div className="input-box">
                                <label>Upload proof of payment</label>
                                <input type="file" placeholder="proof of payment" style={{ padding: '1.2rem' }} onChange={(e) => { setPaymentProof(e.target.files[0]) }} />
                            </div>
                        </div>
                    </div>
                    <Button onClick={handleSubmit} disabled={submitButtonDisable} >Submit</Button>
                </form>
            </div>
            <Loader loading={isLoading} />
        </div>
    );
}

export default RegistrationForm;
